import numeral from 'numeral';
import 'numeral/locales/ja';
import _ from 'lodash'; // lodash使いたくないのでそのうち書き換える

numeral.locale('ja');

export default class NumberHelper {
  static _format(val, format) {
    if (!_.isNumber(val) && !_.isString(val)) {
      return numeral(0).format(format);
    }
    return numeral(val).format(format);
  }

  static format(val) {
    return NumberHelper._format(val, '0,0');
  }

  static formatAmount(val) {
    return NumberHelper._format(val, '$0,0');
  }
}
